import * as React from 'react';
import { IMagazinePageSection } from 'models/common/section';
import { ISectionImageElement } from 'models/common/sectionimageelement';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { default as Slider } from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Link } from 'react-router';
require('./style.css');

interface IProps {
	section: IMagazinePageSection;
	t?: (key: string) => string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewType9 extends React.Component<IProps, any> {
	constructor(props) {
		super(props);
	}

	private renderItem(n: number, mobile = false) {
		const { elements } = this.props.section.data;
		const { t } = this.props;

		return (
			<Link
				to={(elements[n] as ISectionImageElement).redirectUrl}
				className="imageSmall"
				style={{ backgroundImage: `url(${(elements[n] as ISectionImageElement).imageUrl})` }}
			>
				<span
					className="table"
					style={mobile ? { backgroundImage: `url(${(elements[n] as ISectionImageElement).imageUrl})` } : undefined}
				>
					<span className="text">{(elements[n + 1] as ISectionTextElement).text}</span>
				</span>
				<span className="bottomText">
					<span className="byText">{t('Magazine_Section_Common_By')} </span>
					<span className="text">{(elements[n + 2] as ISectionTextElement).text}</span>
				</span>
			</Link>
		);
	}

	public render() {
		const settings = {
			dots: true,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dotsClass: 'type9dots',
		};

		return (
			<div className="container sectionType9container">
				<div className="row desktopShown">
					<div className="col-md-4 no_pad">{this.renderItem(0)}</div>
					<div className="col-md-4 no_pad">{this.renderItem(3)}</div>
					<div className="col-md-4 no_pad">{this.renderItem(6)}</div>
				</div>
				<div className="row mobileShown">
					<Slider {...settings}>
						{this.renderItem(0, true)}
						{this.renderItem(3, true)}
						{this.renderItem(6, true)}
					</Slider>
				</div>
			</div>
		);
	}
}

export { ViewType9 };
